module.exports = __webpack_public_path__ + "static/media/logo-white-v2.5536165e.svg";